export const defaultColorTokens = {
    'twist-color-sky-blue-0': '#b9f6ff',
    'twist-color-sky-blue-5': '#a4f4ff',
    'twist-color-sky-blue-10': '#8ef3ff',
    'twist-color-sky-blue-20': '#66edff',
    'twist-color-sky-blue-30': '#47e2f8',
    'twist-color-sky-blue-40': '#2ed4ef',
    'twist-color-sky-blue-50': '#1cc3e2',
    'twist-color-sky-blue-60': '#0eb0d2',
    'twist-color-sky-blue-70': '#0699be',
    'twist-color-sky-blue-80': '#0181a7',
    'twist-color-sky-blue-90': '#00688c',
    'twist-color-sky-blue-100': '#005070',
    'twist-color-teal-0': '#c1fff7',
    'twist-color-teal-5': '#a8fbf1',
    'twist-color-teal-10': '#8ff8ec',
    'twist-color-teal-20': '#5aebdc',
    'twist-color-teal-30': '#2ed7c8',
    'twist-color-teal-40': '#13bbaf',
    'twist-color-teal-50': '#0d9c92',
    'twist-color-teal-60': '#087d76',
    'twist-color-teal-70': '#05625e',
    'twist-color-teal-80': '#034f4c',
    'twist-color-teal-90': '#00403f',
    'twist-color-teal-100': '#003635',
    'twist-color-lilac-0': '#fcdfff',
    'twist-color-lilac-5': '#f6c1fe',
    'twist-color-lilac-10': '#eca3fc',
    'twist-color-lilac-20': '#e479f8',
    'twist-color-lilac-30': '#dd54f2',
    'twist-color-lilac-40': '#d737ea',
    'twist-color-lilac-50': '#d120df',
    'twist-color-lilac-60': '#cb10d1',
    'twist-color-lilac-70': '#be06ba',
    'twist-color-lilac-80': '#a8009b',
    'twist-color-lilac-90': '#8f007c',
    'twist-color-lilac-100': '#750060',
    'twist-color-dark-blue-0': '#8ec9ff',
    'twist-color-dark-blue-5': '#7ab8ff',
    'twist-color-dark-blue-10': '#65a4fe',
    'twist-color-dark-blue-20': '#3b7cf5',
    'twist-color-dark-blue-30': '#1853eb',
    'twist-color-dark-blue-40': '#002de1',
    'twist-color-dark-blue-50': '#0017d7',
    'twist-color-dark-blue-60': '#0000cd',
    'twist-color-dark-blue-70': '#0001aa',
    'twist-color-dark-blue-80': '#000086',
    'twist-color-dark-blue-90': '#000063',
    'twist-color-dark-blue-100': '#000040',
    'twist-color-orange-0': '#ffb89c',
    'twist-color-orange-5': '#ffa47e',
    'twist-color-orange-10': '#ff9261',
    'twist-color-orange-20': '#ff6f2e',
    'twist-color-orange-30': '#ff4f00',
    'twist-color-orange-40': '#f54800',
    'twist-color-orange-50': '#e83f00',
    'twist-color-orange-60': '#d73500',
    'twist-color-orange-70': '#c22a00',
    'twist-color-orange-80': '#aa1f00',
    'twist-color-orange-90': '#8f1500',
    'twist-color-orange-100': '#730d00',
    'twist-color-purple-0': '#ca9fff',
    'twist-color-purple-5': '#ba7df8',
    'twist-color-purple-10': '#ad5df1',
    'twist-color-purple-20': '#9429e1',
    'twist-color-purple-30': '#8400d1',
    'twist-color-purple-40': '#7400be',
    'twist-color-purple-50': '#6500aa',
    'twist-color-purple-60': '#580097',
    'twist-color-purple-70': '#4c0084',
    'twist-color-purple-80': '#400071',
    'twist-color-purple-90': '#34005d',
    'twist-color-purple-100': '#29004a',
    'twist-color-red-0': '#ffb2ac',
    'twist-color-red-5': '#fe9e98',
    'twist-color-red-10': '#fd8a85',
    'twist-color-red-20': '#f9655f',
    'twist-color-red-30': '#f3433e',
    'twist-color-red-40': '#ec2723',
    'twist-color-red-50': '#e1110f',
    'twist-color-red-60': '#d40000',
    'twist-color-red-70': '#c40300',
    'twist-color-red-80': '#b00600',
    'twist-color-red-90': '#990800',
    'twist-color-red-100': '#820900',
    'twist-color-gold-0': '#ffeaaf',
    'twist-color-gold-5': '#ffe499',
    'twist-color-gold-10': '#ffdd82',
    'twist-color-gold-20': '#fdce54',
    'twist-color-gold-30': '#f8be2c',
    'twist-color-gold-40': '#eeae0a',
    'twist-color-gold-50': '#e2a302',
    'twist-color-gold-60': '#d29702',
    'twist-color-gold-70': '#bd8801',
    'twist-color-gold-80': '#a57701',
    'twist-color-gold-90': '#8a6300',
    'twist-color-gold-100': '#6e4f00',
    'twist-color-gray-0': '#ffffff',
    'twist-color-gray-5': '#f2f2f2',
    'twist-color-gray-10': '#e5e5e5',
    'twist-color-gray-15': '#d9d9d9',
    'twist-color-gray-20': '#cccccc',
    'twist-color-gray-25': '#bfbfbf',
    'twist-color-gray-30': '#b2b2b2',
    'twist-color-gray-35': '#a6a6a6',
    'twist-color-gray-40': '#999999',
    'twist-color-gray-45': '#8c8c8c',
    'twist-color-gray-50': '#808080',
    'twist-color-gray-55': '#737373',
    'twist-color-gray-60': '#666666',
    'twist-color-gray-65': '#595959',
    'twist-color-gray-70': '#4c4c4c',
    'twist-color-gray-75': '#404040',
    'twist-color-gray-80': '#333333',
    'twist-color-gray-85': '#262626',
    'twist-color-gray-90': '#191919',
    'twist-color-gray-95': '#0d0d0d',
    'twist-color-gray-100': '#000000'
};
